// App Services
import Api from './Api';

/**
 * Image Service
 * - It defines all the methods needed for a image convertion.
 */
class ImageService {
  /**
   * Returns an image object with metadata for the image provided via `imageUrl`
   * param. The metadata are the standard things from the image DOM object, such
   * as width, height, dataset.
   * @param {String} imageUrl
   * @return {Promise}
   */
  static getImageMetadata(imageUrl) {
    return new Promise((resolve, reject) => {
      const image = document.createElement('img');
      image.src = imageUrl;
      image.onload = () => resolve(image);
      image.onerror = e => reject(e);
    });
  }

  /**
   * It fetches the image and gets the binary.
   * @param  {String} imageUrl a `image object URL` or `image url` to get the image binary.
   * @return {Promise}
   */
  static getImageBlobFromImageUrl(imageUrl) {
    const config = {
      responseType: 'blob',
    };
    return Api.get(imageUrl, config)
      .then(response => response.data);
  }

  /**
   * It will get the base64 image from the binary.
   * @param  {Object} blobImage blob image object
   * @return {Promise}
   */
  getImageBase64(blobImage) {
    return new Promise((resolve, reject) => {
      const reader = new window.FileReader();

      reader.onload = (event) => {
        resolve(event.target.result);
      };

      reader.onerror = event => reject(event);

      reader.readAsDataURL(blobImage, 'utf-8');
    });
  }
}

export default ImageService;



// WEBPACK FOOTER //
// ./src/services/ImageService.js